import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useIsClient } from 'usehooks-ts';

export function Portal({ children }: { children: ReactNode }) {
  const isClient = useIsClient();

  const root =
    typeof document === 'object' ? document.querySelector('#portal') : null;

  return isClient && root ? createPortal(children, root) : null;
}
